<template>
  <div class="coronavirus">
    <div class="imgBox">
      <img src="../../../assets/coronavirusIMG.png" alt="" />
    </div>
    <div class="videoEntry">
      <div class="title">注意事项</div>
      <div>
        1、用户必须确保本人为受检者，如因冒名顶替采样由此带来的法律风险及后果由用户本人承担;
      </div>
      <div>
        2、用户订单支付后，以下情况，费用不予退还：（1）用户未按预约时间到约定采样点采样;（2）用户自行取消采样服务;
      </div>
      <div>3、新冠核酸检测报告单（日文版）需要彩色打印</div>
      <div class="videoLink">
        视频教学链接：<span @click="goVideoLink">点击进入</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {
    goVideoLink() {
      window.open(
        'http://m.youku.com/v_show/id_XNDkyNzAxMTM0MA==.html?pgcpgcid=UNDY2MjkwNDgyMA%3D%3D&sharekey=4e83eca367941b89dc47383900de59ee6'
      )
    }
  }
}
</script>

<style scoped lang="scss">
.coronavirus {
  .imgBox {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
  }
  .videoEntry {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #ff0000;
    line-height: 38px;
    padding: 45px 0 55px 200px;
    background-color: #f1f6f7;
    .title {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000000;
      line-height: 50px;
    }
    .videoLink {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #5a96ec;
      line-height: 38px;
      span {
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/website/coronavirus/coronavirus.vue